<template>
  <div class="boss-main-wrap boss-main-content-wrap">
    <setting-header
      :breadcrumbs="[{ name: '社員からの評判', pathName: 'realIntentionTop' }]"
      :title="`社員からの評判＿${title}`"
      data-test="title-real-intention"
    />
    <div>
      <span class="text-center margin-2">
        <div
          data-test="notification-first-line"
          v-text="notificationFirstLine"
        />
        <div
          data-test="notification-second-line"
          v-text="notificationSecondLine"
        />
      </span>
    </div>
    <div>
      <real-intention-preview-content
        :real-intention="realIntentionPreviewContent"
        inner-style="border: 1px solid #777777;"
        data-test="real-intention-preview-content"
      />
    </div>
    <div>
      <form-button-area>
        <form-back-button
          data-test="back-button"
          @back="back"
        />
      </form-button-area>
    </div>
    <div>
      <form-button-area>
        <form-confirm-button
          submit-label="非公開で保存する"
          data-test="unpublish-button"
          class="pega-unpublish-button"
          @submit-event="onUnPublishRegisterClick"
        />
        <form-confirm-button
          submit-label="この内容で公開する"
          data-test="publish-button"
          @submit-event="onPublishRegisterClick"
        />
      </form-button-area>
    </div>
  </div>
</template>

<script>
import { realIntentionRegister } from '@/lib/labelValueMappings'
import dayjs from 'dayjs'
import SettingHeader from '@/components/atoms/SettingHeader'
import FormConfirmButton from '@/components/atoms/FormConfirmButton'
import FormBackButton from '@/components/atoms/FormBackButton'
import FormButtonArea from '@/components/atoms/FormButtonArea'
import RealIntentionPreviewContent from '@/components/organisms/RealIntentionPreviewContent'

export default {
  components: {
    RealIntentionPreviewContent,
    FormButtonArea,
    FormConfirmButton,
    FormBackButton,
    SettingHeader
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    realIntention: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      realIntentionOptions: realIntentionRegister
    }
  },
  computed: {
    realIntentionPreviewContent () {
      return {
        age: this.realIntention.age,
        gender: this.realIntention.gender,
        serviceYear: this.realIntention.serviceYear,
        post: this.realIntention.post,
        career: this.realIntention.career,
        icon: this.realIntention.icon,
        question1: this.realIntention.question1,
        question2: this.realIntention.question2,
        question3: this.realIntention.question3,
        createDate: dayjs().toDate()
      }
    },
    title () {
      return this.isEdit ? '編集確認' : '登録確認'
    },
    notificationFirstLine () {
      return this.isEdit ? 'こちらの内容でよろしいですか？' : 'まだ完了しておりません。'
    },
    notificationSecondLine () {
      return this.isEdit ? '修正する際には「戻る」を押してください。' : '内容をご確認の上「この内容で公開する」ボタンを押してください。'
    }
  },
  methods: {
    onPublishRegisterClick () {
      this.$emit('publish')
    },
    onUnPublishRegisterClick () {
      this.$emit('un-publish')
    },
    back () {
      this.$emit('back')
    }
  }
}
</script>
